import React from 'react';

import TruncatedText from 'components/generic/TruncatedText.component';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const StylistButton = (props) => {
  const thistSylist = props.activeStylists.filter((s) => s.user_name === props.name)[0];
  let candoThisService;

  // time off
  if (typeof props.service === 'string') {
    candoThisService = true;
  } else {
    candoThisService = thistSylist && thistSylist.role && thistSylist.role.services && thistSylist.role.services.filter((s) => s.service_id === props.service.service_id).length > 0;
  }

  const selectedStylistTrimmed = fromAnyToTrimmed(props.selectedStylist);
  const nameTrimmed = props.name?.trim() ?? '';
  const checked = selectedStylistTrimmed === nameTrimmed;

  let className = !checked ? 'the-stylist-button' : 'the-stylist-button selected';

  if (!candoThisService) {
    className += ' not-qualified';
  }

  return (
    <div className={className} role="button" tabIndex={0} onClick={props.changeStylist}>
      <div className="item-option">
        <div role="button" tabIndex="-1">
          <TruncatedText max={28} suffix="..." value={props.name} />
          {className.indexOf('not-qualified') > 0 && <div className="not-qualified-line" />}
        </div>
      </div>
    </div>
  );
};

export default StylistButton;
